import { Button } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import React from 'react';

import type { EdutainmentApplication } from '../../types';

export const getTableColumns = (
  onReviewButtonClick: (record: EdutainmentApplication) => void
) => {
  const columns: ColumnsType<EdutainmentApplication> = [
    {
      title: '育樂名稱',
      dataIndex: 'name',
    },
    {
      title: '所屬計費方案',
      dataIndex: 'plans',
      width: 300,
      render: (plans: string[]) => {
        return plans.join('/');
      },
    },
    {
      title: '育樂類別',
      dataIndex: 'category',
    },
    {
      title: '審核截止日期(年/月/日)',
      dataIndex: 'reviewDeadline',
      render: (deadline: number) => {
        return dayjs(deadline).format('YYYY/MM/DD HH:mm:ss');
      },
      sorter: (a, b) => a.reviewDeadline - b.reviewDeadline,
    },
    {
      title: '育樂開始日期(年/月/日)',
      dataIndex: 'startDate',
      render: (startDate: number) => {
        return dayjs(startDate).format('YYYY/MM/DD');
      },
      sorter: (a, b) => a.startDate - b.startDate,
    },
    {
      title: '育樂結束日期(年/月/日)',
      dataIndex: 'endDate',
      render: (endDate: number) => {
        return dayjs(endDate).format('YYYY/MM/DD');
      },
      sorter: (a, b) => a.endDate - b.endDate,
    },
    {
      title: '育樂時間',
      dataIndex: 'times',
      width: 300,
      render: (times: string[]) => {
        return times.join('/');
      },
    },
    {
      title: '講師',
      dataIndex: 'teacher',
    },
    {
      title: '操作',
      dataIndex: 'action',
      fixed: 'right',
      render: (_, record) => {
        return (
          <Button type="primary" onClick={() => onReviewButtonClick(record)}>
            審核
          </Button>
        );
      },
    },
  ];
  return columns;
};
